import LoadingScreen from "@/components/ui/loading-screen";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/auth_callback")({
  component: () => <LoadingScreen message="Logging in..." />,
});
